import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import ChatPage from './pages/ChatPage'
import AppShell from './components/AppShell'
import { ErrorBoundary } from './components/ErrorBoundary'
import { Toaster } from './hooks/useToast'
import AlphaGate from './components/AlphaGate'

// GlobePage pulls in Three.js (~700 kB) and the SGP4 propagation worker, which
// only the /globe tab needs. Chat is the default route, so eager-importing the
// globe forced every chat user to download Three up front. Lazy-load it to
// code-split Three out of the initial bundle; it loads on first /globe visit.
const GlobePage = lazy(() => import('./pages/GlobePage'))

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Toaster />
        <AlphaGate>
          <Routes>
            {/* AppShell provides the Chat | Globe tab bar; pages render in its Outlet. */}
            <Route element={<AppShell />}>
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/chat/:sessionId" element={<ChatPage />} />
              <Route
                path="/globe"
                element={
                  <Suspense fallback={<div style={{ padding: '2rem', color: '#888', fontFamily: 'ui-monospace, monospace' }}>Loading globe…</div>}>
                    <GlobePage />
                  </Suspense>
                }
              />
            </Route>
            <Route path="/" element={<Navigate to="/chat" replace />} />
          </Routes>
        </AlphaGate>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
